// Datos del test «¿De qué te estás escapando?». Las plantillas leen de aquí: el texto no va en el HTML.
// Las respuestas se calculan en el navegador y no salen de él hasta que hay email y consentimiento.
(function (global) {
  const CONFIG = {
    nombre: "¿De qué te estás escapando?",
    firma: "Dioni",
    minutos: 4,
    // true: se puede enseñar sin CRM ni privacidad. Antes de publicar, poner false: sin ambos, el formulario no se envía.
    demo: true,
    // Pendientes: mientras sean null, su bloque no se pinta.
    urls: {
      reto: "/pages/reto-14-dias",
      condiciones: "/policies/refund-policy",
      newsletter: null,
      youtube: null,
      llamada: null,
    },
    // true: el informe de conciencia media enseña el reto. false: solo llega por la secuencia de emails.
    mostrarRetoEnInforme: true,
    privacidad: {
      responsable: null, // Pendiente: titular de los datos.
      url: null, // Pendiente: política de privacidad.
    },
  };

  const PORTADA = {
    titular: "¿De qué te estás escapando?",
    subtitular: "14 preguntas sobre tu última hora del día. Al final, un informe escrito sobre lo que estás tapando y qué hacer con ello.",
    boton: "Empezar el test",
    nota: "Unos 4 minutos. Gratis. Nadie ve tus respuestas mientras contestas.",
    aviso: "No es un diagnóstico médico ni psicológico, ni sustituye a un profesional.",
  };

  const CAPTURA = {
    titular: "Tu informe está listo",
    texto: "Dime dónde te lo mando y te lo enseño ahora mismo.",
    campoNombre: "Tu nombre",
    campoEmail: "Tu email",
    consentimientoDatos: "Tengo 18 años o más y acepto que se guarden mis respuestas para elaborar mi informe, incluidas las que pueden revelar datos sobre mi salud o consumo de sustancias.",
    consentimientoCorreos: "Acepto que se usen esas respuestas para personalizar los correos que reciba.",
    consentimientoComercial: "Quiero recibir correos con contenido y ofertas.",
    boton: "Ver mi informe",
    nota: "Puedes darte de baja en cualquier correo.",
  };

  const PREGUNTAS = [
    // Dónde se evade
    {
      id: "p1",
      texto: "Son las doce. Mañana madrugas. ¿Qué estás haciendo de verdad?",
      opciones: [
        { texto: "Mirando el móvil o una serie que ni me interesa", suma: { pantallas: 2 } },
        { texto: "Contestando cosas del trabajo o dándoles vueltas", suma: { trabajo: 2 } },
        { texto: "En el sofá con mi pareja, cada uno a lo suyo", suma: { pareja: 2 } },
        { texto: "Con una copa, un porro o algo para bajar revoluciones", suma: { sustancias: 2 } },
        { texto: "Liado con recados, planes o lo que tenga pendiente", suma: { agenda: 2 } },
      ],
    },
    {
      id: "p2",
      texto: "Si te quedas diez minutos sin hacer nada, ¿qué pasa?",
      opciones: [
        { texto: "Cojo el móvil sin darme cuenta", suma: { pantallas: 1 } },
        { texto: "Me acuerdo de algo que tengo que resolver", suma: { trabajo: 1 } },
        { texto: "Hablo con quien tenga al lado, de lo que sea", suma: { pareja: 1 } },
        { texto: "Me pongo inquieto hasta que me tomo algo", suma: { sustancias: 1 } },
        { texto: "No lo sé: nunca tengo diez minutos", suma: { agenda: 1 } },
      ],
    },
    {
      id: "p3",
      texto: "¿Qué te costaría más dejar durante 14 noches?",
      opciones: [
        { texto: "El móvil en la cama", suma: { pantallas: 2 } },
        { texto: "Mirar el correo o los números antes de dormir", suma: { trabajo: 2 } },
        { texto: "La rutina de casa, aunque casi no hablemos", suma: { pareja: 2 } },
        { texto: "Lo que tomo para desconectar", suma: { sustancias: 2 } },
        { texto: "Tener algo que hacer todas las noches", suma: { agenda: 2 } },
      ],
    },
    {
      id: "p4",
      texto: "¿Qué te dirían los que te conocen si fueran sinceros?",
      opciones: [
        { texto: "«Siempre estás con el móvil»", suma: { pantallas: 1 } },
        { texto: "«Solo hablas de trabajo»", suma: { trabajo: 1 } },
        { texto: "«Estás, pero no estás»", suma: { pareja: 1 } },
        { texto: "«Cuando tomas algo eres otro»", suma: { sustancias: 1 } },
        { texto: "«No paras nunca»", suma: { agenda: 1 } },
      ],
    },
    {
      id: "p5",
      texto: "Un día te ha ido mal. ¿Adónde te vas por la noche?",
      opciones: [
        { texto: "A la pantalla que tenga más cerca", suma: { pantallas: 2 } },
        { texto: "A trabajar un rato más", suma: { trabajo: 2 } },
        { texto: "A hacer como que no ha pasado nada en casa", suma: { pareja: 2 } },
        { texto: "A la copa o a lo que me calme", suma: { sustancias: 2 } },
        { texto: "A llenar la noche con lo que sea, menos pararme", suma: { agenda: 2 } },
      ],
    },
    // Perfil
    {
      id: "p6",
      texto: "Desde fuera, ¿qué dirían de tu vida?",
      opciones: [
        { texto: "«Lo tiene todo»", suma: { vacio: 2 } },
        { texto: "«Cómo curra este tío»", suma: { escudo: 2 } },
        { texto: "«Qué bien le va con los suyos»", suma: { acompanado: 2 } },
        { texto: "«Este lo tiene todo muy claro»", suma: { sabe: 2 } },
      ],
    },
    {
      id: "p7",
      texto: "¿Qué frase te escuece más?",
      opciones: [
        { texto: "Tienes lo que querías y no sientes gran cosa", suma: { vacio: 2 } },
        { texto: "Trabajas tanto para no mirar lo demás", suma: { escudo: 2 } },
        { texto: "Estás rodeado y nadie sabe cómo estás", suma: { acompanado: 2 } },
        { texto: "Llevas años sabiendo lo que tienes que hacer", suma: { sabe: 2 } },
      ],
    },
    {
      id: "p8",
      texto: "¿Qué te cuesta más reconocer?",
      opciones: [
        { texto: "Que no sé para qué hago todo esto", suma: { vacio: 2 } },
        { texto: "Que sin el trabajo no sé quién soy", suma: { escudo: 2 } },
        { texto: "Que me siento solo aunque esté con gente", suma: { acompanado: 2 } },
        { texto: "Que he empezado lo mismo demasiadas veces", suma: { sabe: 2 } },
      ],
    },
    {
      id: "p9",
      texto: "Apagas la luz. ¿Qué te ronda?",
      opciones: [
        { texto: "«¿Y ahora qué?»", suma: { vacio: 1 } },
        { texto: "Todo lo de mañana", suma: { escudo: 1 } },
        { texto: "Una conversación que no estoy teniendo", suma: { acompanado: 1 } },
        { texto: "«Mañana empiezo»", suma: { sabe: 1 } },
      ],
    },
    // Nivel de conciencia
    {
      id: "p10",
      texto: "Cuando oyes «te evades por las noches», piensas…",
      opciones: [
        { texto: "No va conmigo: solo me gusta trasnochar", suma: { conciencia: 0 } },
        { texto: "Algo hay, pero no sabría decir qué", suma: { conciencia: 1 } },
        { texto: "Sé de qué me escapo, aunque no haga nada", suma: { conciencia: 2 } },
        { texto: "Lo sé y estoy buscando cómo salir", suma: { conciencia: 3 } },
      ],
    },
    {
      id: "p11",
      texto: "¿Cuántas veces te has dicho «a partir del lunes»?",
      opciones: [
        { texto: "Pocas: no hay gran cosa que cambiar", suma: { conciencia: 0 } },
        { texto: "Alguna, sin darle importancia", suma: { conciencia: 1 } },
        { texto: "Tantas que ya no me creo", suma: { conciencia: 2 } },
        { texto: "He dejado de decirlo: quiero hacer algo ya", suma: { conciencia: 3 } },
      ],
    },
    {
      id: "p12",
      texto: "Si esta semana pudieras hablarlo con alguien…",
      opciones: [
        { texto: "No me hace falta", suma: { conciencia: 0 } },
        { texto: "Quizá, pero no sabría qué decir", suma: { conciencia: 1 } },
        { texto: "Debería, y lo voy posponiendo", suma: { conciencia: 2 } },
        { texto: "Lo haría ya", suma: { conciencia: 3 } },
      ],
    },
    // Capacidad y disposición a invertir
    {
      id: "p13",
      texto: "¿Cómo es tu trabajo ahora mismo?",
      opciones: [
        { texto: "Estudio o estoy buscando", suma: { capacidad: 0 } },
        { texto: "Trabajo por cuenta ajena", suma: { capacidad: 1 } },
        { texto: "Dirijo un equipo o un área", suma: { capacidad: 2 } },
        { texto: "Tengo mi negocio o soy autónomo", suma: { capacidad: 2 } },
      ],
    },
    {
      id: "p14",
      texto: "¿Alguna vez has pagado por trabajar en ti mismo?",
      opciones: [
        { texto: "No, nunca", suma: { capacidad: 0 } },
        { texto: "Algún libro o curso barato", suma: { capacidad: 1 } },
        { texto: "Sí, una formación o un acompañamiento de verdad", suma: { capacidad: 2 } },
      ],
    },
  ];

  const PERFILES = {
    vacio: {
      nombre: "El que lo tiene todo",
      frase: "Has llegado a donde querías, y por la noche no hay nadie para celebrarlo.",
      texto: "De día las cosas funcionan. Por eso cuesta tanto decirlo: no te falta nada que se pueda enseñar. Lo que falta aparece cuando se acaba la lista y no queda nada que hacer. Entonces llenas el rato, porque quedarte ahí te obliga a una pregunta que no sabes contestar: para qué todo esto.",
    },
    escudo: {
      nombre: "El del escudo",
      frase: "Tu trabajo es de verdad. Y también es el mejor sitio para esconderte.",
      texto: "Nadie te va a reprochar que trabajes. Es la evasión con mejor prensa que existe. Pero mira cuándo la usas: cuando en casa hay una conversación pendiente, cuando el día ha salido torcido, cuando por fin hay silencio. Mientras haya algo que resolver, no tienes que mirar lo que no se resuelve con una lista de tareas.",
    },
    acompanado: {
      nombre: "El acompañado y solo",
      frase: "Tienes con quién cenar. No tienes con quién decir cómo estás.",
      texto: "Hay gente a tu alrededor y ninguna de esas personas sabe de verdad cómo estás, en parte porque nunca se lo has dado a saber. Has aprendido a estar sin estar. Esa soledad no se arregla con más planes: se nota más cuando la casa se queda en silencio y sigues sin decir nada.",
    },
    sabe: {
      nombre: "El que lo sabe todo",
      frase: "Podrías dar tú la charla. Y mañana volverías a lo mismo.",
      texto: "Has leído, has escuchado y sabes explicar lo que te pasa mejor que mucha gente. El problema no es de información. Saber se ha convertido en otra forma de no hacer: mientras lo entiendes, no tienes que moverte. Cada lunes que no llega te quita algo que ya notas: la confianza en tu propia palabra.",
    },
  };

  const EVASIONES = {
    pantallas: {
      nombre: "Las pantallas",
      texto: "Tu vía de escape está en la mano. No la usas porque te interese lo que ves, sino porque mientras miras no estás contigo. Fíjate en la próxima vez que abras el móvil sin saber para qué: justo antes, algo te incomodó. Eso es lo que estás tapando.",
    },
    trabajo: {
      nombre: "El trabajo",
      texto: "Tu vía de escape parece una virtud, y por eso nadie te avisa. Si mirar el correo a medianoche no cambia nada de lo de mañana, no es responsabilidad: es un sitio al que ir. La pregunta no es cuánto trabajas, sino qué pasaría si esta noche no lo hicieras.",
    },
    pareja: {
      nombre: "Estar sin estar",
      texto: "Tu vía de escape es la inercia: compartir sofá sin compartir nada. No hace ruido y por eso puede durar años. No hace falta que pase nada grave para que falte algo. Lo que evitas es esa conversación que llevas tiempo posponiendo, también contigo.",
    },
    sustancias: {
      nombre: "Lo que tomas para desconectar",
      texto: "Tu vía de escape baja el volumen por fuera y lo deja igual por dentro. No hace falta ponerle etiqueta para ver lo que hace: te ahorra estar a solas sin nada de por medio. Si notas que se te va de las manos, cuéntaselo a un médico o a un profesional. Este test no sustituye esa conversación.",
    },
    agenda: {
      nombre: "La agenda llena",
      texto: "Tu vía de escape es no parar. Planes, recados, gente, lo que sea, siempre que no quede un hueco. Desde fuera parece energía. Pero si un rato sin nada que hacer te pone nervioso, la agenda no es tu vida: es lo que la mantiene a distancia.",
    },
  };

  const CONCIENCIA = {
    no_lo_ve: {
      nombre: "Todavía no lo ves",
      texto: "Por tus respuestas, ahora mismo esto no te parece un problema. Puede que no lo sea. No hace falta que te convenzas de nada: quédate con una pregunta esta semana. ¿Qué haces en tu última hora del día, y qué pasaría si no lo hicieras?",
    },
    lo_intuye: {
      nombre: "Lo intuyes",
      texto: "Sabes que algo no encaja, aunque no le pongas nombre. Es un momento incómodo, y también el más útil: todavía no has convertido el problema en una historia que te cuentas. Ponerlo por escrito ya cambia cosas.",
    },
    lo_sabe: {
      nombre: "Lo sabes y no te mueves",
      texto: "Tienes claro de qué te escapas. Lo que no tienes es un sitio donde hacer algo con ello. Otra lectura no te va a ayudar, y otro lunes tampoco. Lo que suele faltar en este punto es algo pequeño, concreto y que puedas cumplir esta misma noche.",
    },
    busca: {
      nombre: "Ya estás buscando",
      texto: "Has dejado de preguntarte si te pasa algo y te preguntas qué hacer. Eso es lo más difícil, y ya lo has hecho. A partir de aquí lo importante es no quedarte coleccionando respuestas: elige una vía y sostenla.",
    },
  };

  const SIGUIENTE_PASO = {
    baja: {
      titular: "No te voy a vender nada",
      texto: "Te escribiré de vez en cuando sobre esto. Léelo si te sirve y bórralo si no.",
      textoSinCorreos: "Quédate con lo que has leído. Vuelve a ello dentro de una semana.",
      botones: [
        { texto: "Leer la newsletter", url: "newsletter" },
        { texto: "Ver los vídeos", url: "youtube" },
      ],
    },
    media: {
      titular: "Lo siguiente, si quieres hacer algo con esto",
      texto: "El reto son 14 noches, un audio de 7 a 12 minutos cada noche y escritura guiada, justo en la hora de la que hablamos. No es terapia ni una ayuda para dormir. Garantía de palabra: si haces las 14 noches y no notas nada, te devolvemos los 27 €.",
      condiciones: { texto: "Condiciones de la garantía", url: "condiciones" },
      botones: [{ texto: "Empezar esta noche · 27 €", url: "reto" }],
    },
    alta: {
      titular: "Hablemos",
      texto: "Por lo que has contestado, un audio al día se te puede quedar corto. Si quieres, lo vemos en una llamada y miramos si tiene sentido trabajarlo juntos. No es terapia ni un tratamiento: si lo que te preocupa es lo que tomas, empieza por un médico.",
      botones: [{ texto: "Pedir la llamada", url: "llamada" }],
    },
  };

  const CIERRE = {
    aviso: "Este informe nace de tus respuestas a un test. No es un diagnóstico médico ni psicológico.",
    ayuda: "Si estás pasando por un mal momento o has pensado en hacerte daño, no lo lleves solo. En España puedes llamar al 024 a cualquier hora, gratis y de forma confidencial. En una emergencia, al 112.",
  };

  const ORDEN_EVASIONES = ["pantallas", "trabajo", "pareja", "sustancias", "agenda"];
  const ORDEN_PERFILES = ["vacio", "escudo", "acompanado", "sabe"];

  const mayor = (claves, puntos) => claves.reduce((a, b) => ((puntos[b] || 0) > (puntos[a] || 0) ? b : a));

  // respuestas: { p1: índice de la opción, p2: …, … }
  function calcular(respuestas) {
    const puntos = {};
    for (const p of PREGUNTAS) {
      const suma = p.opciones[respuestas[p.id]].suma;
      for (const k in suma) puntos[k] = (puntos[k] || 0) + suma[k];
    }
    const c = puntos.conciencia || 0;
    const conciencia = c <= 2 ? "no_lo_ve" : c <= 4 ? "lo_intuye" : c <= 6 ? "lo_sabe" : "busca";
    const conCapacidad = (puntos.capacidad || 0) >= 3;
    const ruta = conciencia === "no_lo_ve" ? "baja" : conciencia === "busca" && conCapacidad ? "alta" : "media";
    return {
      perfil: mayor(ORDEN_PERFILES, puntos),
      evasion: mayor(ORDEN_EVASIONES, puntos),
      conciencia,
      ruta,
      puntos,
    };
  }

  // Punto único de conexión con el CRM de Dani. Sin conectar: no envía nada y devuelve false.
  async function enviarAlCRM(_datos) {
    return false;
  }

  const TEST = { CONFIG, PORTADA, CAPTURA, PREGUNTAS, PERFILES, EVASIONES, CONCIENCIA, SIGUIENTE_PASO, CIERRE, calcular, enviarAlCRM };
  if (typeof module !== "undefined" && module.exports) module.exports = TEST;
  else global.TEST = TEST;
})(typeof window !== "undefined" ? window : globalThis);
